/* eslint-disable node/no-unsupported-features/es-syntax */
import { GENERAL_ROUTE_NAMES, PROFILE_ROUTE_NAMES } from "@/shared";

export const GENERAL_ROUTES = [
    {
        path: "/:pathMatch(.*)*",
        name: GENERAL_ROUTE_NAMES.NOT_FOUND,
        meta: {
            title: "errors.page_not_found",
        },
        component: () => import("../ui/NotFound.vue"),
    },
    {
        path: "/tariff-extend",
        name: GENERAL_ROUTE_NAMES.BUY_TARIFF,
        meta: {
            title: "words.tariff_renewal",
        },
        component: () => import("../../payment/ui/PaymentPage.vue"),
    },
    {
        path: "/",
        name: GENERAL_ROUTE_NAMES.DEFAULT,
        redirect: { name: PROFILE_ROUTE_NAMES.PROFILE },
    },
    {
        path: "/support",
        name: "REMBOARD_SUPPORT",
        beforeEnter() {
            window.open("mailto:support@remboard.ru", "_blank");

            return false;
        },
    },
];
